import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Roadmap } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './life-area-goals-empty-state.style';

type LifeAreaGoalsEmptyStateProps = {
  onAdd: () => void;
};

export const LifeAreaGoalsEmptyState: React.FC<
  LifeAreaGoalsEmptyStateProps
> = ({ onAdd }) => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <Styled.IconContainer>
        <Icon icon={Roadmap} />
      </Styled.IconContainer>

      <Styled.Content>
        <Typography variant="subtitle2">
          {t('pages.life-areas.goals.empty.title')}
        </Typography>
        <Styled.Description>
          {t('pages.life-areas.goals.empty.description')}
        </Styled.Description>
      </Styled.Content>

      <Styled.Interactions>
        <Button
          variant={Variants.Contained}
          color={Colors.Primary}
          size={Sizes.Small}
          onClick={onAdd}
        >
          {t('pages.life-areas.goals.empty.button.label')}
        </Button>
      </Styled.Interactions>
    </Styled.Container>
  );
};
